<template>
  <div>
    <span v-if="item.calculationMethod == 0">
      填写条数 >= {{ item.scoringRangeStart }} 条时，给 {{ item.score }} 分
    </span>
    <span v-if="item.calculationMethod == 1">
      每填报一条给 {{ item.score }} 分, 累加上限数量
      {{ item.scoringRangeEnd - item.scoringRangeStart + 1 }}
    </span>
    <span v-if="item.calculationMethod == 2">
      每填报一条给 {{ item.score }} 分, 可累加
    </span>
    <span v-if="item.calculationMethod == 3">
      按完成率计分，项目分为
      {{ item.score }}
      分;若巡查完成率为 90%，则实际得分为 90% * {{ item.score }} =
      {{ item.score * 0.9 }}
      分
    </span>
  </div>
</template>
<script>
export default {
  name: "",
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  created() {
    // console.log(this.item);
  },
  mounted() {},
  methods: {},
  computed: {}
};
</script>
<style scoped lang="scss"></style>
